import type { ReactNode } from "react";

interface FormFieldProps {
    id: string;
    label: string;
    error?: string;
    children: ReactNode;
}

// A labelled field of the admin client drawers (Edit Organization, Edit
// Location), with its rule's message under it.
export const FormField = ({ id, label, error, children }: FormFieldProps) => (
    <div>
        <label htmlFor={id} className="mb-1 block text-sm font-semibold">
            {label}
        </label>
        {children}
        {error && <p className="mt-1 text-sm text-error">{error}</p>}
    </div>
);

export const INPUT_CLASS = "input input-bordered w-full bg-white text-neutral";
